module.exports = __webpack_public_path__ + "static/media/np.203c008f.webp";